import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M18.054 4.394 4.17 9.272l5.63 3.377zM10.86 13.71l3.377 5.628 4.878-13.884zM21.45 3.333a1 1 0 0 0-1.275-1.275L2.67 8.21a1 1 0 0 0-.183 1.801l6.882 4.13 4.13 6.883a1 1 0 0 0 1.801-.183z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }